/**
 * Template - Data mapper for RFI2 - Fabric
 * Section UID (in template) : Section Path in data
 */
export const rfi2FabricSectionMapper = {
  //Business Capabilities
  top_fabrics_sold: 'dynamic_sections.business_capability.top_fabrics_sold',
  manufacturing_processes:
    'dynamic_sections.business_capability.manufacturing_processes',
  certifications: 'dynamic_sections.business_capability.certifications',

  //Supply Chain
  top_garment_vendors: 'dynamic_sections.supply_chain.top_garment_vendors',

  //Responsible Sourcing
  responsible_sourcing_sustainability_for_fabric:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability_for_fabric',

  //Other Information
  additional_factory_information:
    'dynamic_sections.other_information.additional_factory_information',
  key_factory_personnel:
    'dynamic_sections.other_information.key_factory_personnel',
  
   factory_automation_level:
    'dynamic_sections.other_information.factory_automation_level',
  
  employee_information:
    'dynamic_sections.other_information.employee_information',
  factory_ownership: 'dynamic_sections.other_information.factory_ownership',
  financial_information:
    'dynamic_sections.other_information.financial_information',
}
